import {
  DISMISS_NOTIFICATION_ASYNC,
  FETCH_APP_DATA_ASYNC,
  REFETCH_OWNER_STATUS_ASYNC,
  UPDATE_AI_CREDITS_NOTIFICATION,
} from './constants'

export const fetchAppData = () => ({ type: FETCH_APP_DATA_ASYNC.INITIATE })
export const fetchAppDataSuccess = (data) => ({
  type: FETCH_APP_DATA_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAppDataError = (error) => ({
  type: FETCH_APP_DATA_ASYNC.ERROR,
  error,
})

export const refetchOwnerStatusSuccess = (data) => ({
  type: REFETCH_OWNER_STATUS_ASYNC.SUCCESS,
  payload: { data },
})
export const refetchOwnerStatusError = (error) => ({
  type: REFETCH_OWNER_STATUS_ASYNC.ERROR,
  error,
})

export const updateAiCreditsNotification = (aiCreditsNotification) => ({
  type: UPDATE_AI_CREDITS_NOTIFICATION,
  payload: aiCreditsNotification,
})

export const dismissNotification = (payload) => DISMISS_NOTIFICATION_ASYNC.initiate(payload)

export default {
  // to props
  fetchAppData,
}
